import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { MdCheck } from "react-icons/md";
import "./DropdownMenu.css";

function DropdownMenu({
  anchorEl,
  options = [],
  selected,
  onSelect,
  onClose,
}) {
  const menuRef = useRef(null);

  const [position, setPosition] = useState({
    top: 0,
    left: 0,
    width: 220,
  });

  useEffect(() => {
    if (!anchorEl) return;

    const updatePosition = () => {
      const rect = anchorEl.getBoundingClientRect();

      setPosition({
        top: rect.bottom + window.scrollY + 10,
        left: rect.left + window.scrollX,
        width: Math.max(rect.width, 220),
      });
    };

    updatePosition();

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition, true);

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition, true);
    };
  }, [anchorEl]);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(event.target) &&
        anchorEl &&
        !anchorEl.contains(event.target)
      ) {
        onClose?.();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener(
        "mousedown",
        handleOutsideClick
      );
    };
  }, [anchorEl, onClose]);
    return createPortal(
    <div
      ref={menuRef}
      className="dropdown-menu"
      style={{
        top: position.top,
        left: position.left,
        minWidth: position.width,
      }}
    >
      {options.length === 0 ? (
        <div className="dropdown-empty">
          No options available
        </div>
      ) : (
        options.map((option) => {
          const value =
            typeof option === "string"
              ? option
              : option.value;

          const label =
            typeof option === "string"
              ? option
              : option.label;

          const isSelected = selected === value;

          return (
            <button
              key={value}
              type="button"
              className={`dropdown-item ${
                isSelected ? "selected" : ""
              }`}
              onClick={() => {
                onSelect?.(value);
              }}
            >
              <span className="dropdown-label">
                {label}
              </span>

              {isSelected && (
                <span className="dropdown-check">
                  <MdCheck />
                </span>
              )}
            </button>
          );
        })
      )}
          </div>,
    document.body
  );
}

export default DropdownMenu;